exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".validatingInput .subText{margin-bottom:0;text-align:left;font-size:.8em;margin-left:13px}.validatingInput .subText.errorDisplay{color:#c31030}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/validating_input.scss
// module id = 1490
// module chunks = 0